import lodashSet from 'lodash/set'
import lodashGet from 'lodash/get'

const overrideDirectory = '../library/schema/common/'
const jsonModules = import.meta.glob(`../library/schema/*/*.json`)
// find common schema json file
const findOverrideSchema = async (path) => {
  const currentPath = `${overrideDirectory}${path}.json`
  const result = Object.entries(jsonModules).find(([modulePath, _]) => modulePath == currentPath)

  if (!result) return null
  const [_, module] = result
  const overrideObj = await module()
  return overrideObj.default
}
// find and set one field of schema
const findAndSetSchema = async (allJson, formItem, idx, index) => {
  for (let schemaIdx = 0; schemaIdx < formItem.schema.length; schemaIdx++) {
    let schemaItem = formItem.schema[schemaIdx]
    const oneSchemaFieldPath = `steps[${idx}]form[${index}]schema[${schemaIdx}]`
    // override one filed of schema
    const overrideTemplateSchema = async (schemaItem) => {
      for (
        let nestedTemplateIdx = 0;
        nestedTemplateIdx < schemaItem.template_schema.length;
        nestedTemplateIdx++
      ) {
        let nestedFormItemPath = `steps[${idx}]form[${index}]schema[${schemaIdx}]template_schema[${nestedTemplateIdx}]`
        let nestedTemplateItem = schemaItem.template_schema[nestedTemplateIdx]
        if (nestedTemplateItem?.override) {
          const overrideObj = await findOverrideSchema(nestedTemplateItem.override.name)
          nestedTemplateItem = {
            ...overrideObj,
            ...nestedTemplateItem
          }
          lodashSet(allJson, nestedFormItemPath, nestedTemplateItem)
        }
      }
    }
    if (schemaItem.override) {
      const overrideObj = await findOverrideSchema(schemaItem.override.name)
      schemaItem = {
        ...overrideObj,
        ...schemaItem
      }
      lodashSet(allJson, oneSchemaFieldPath, schemaItem)
      // override one filed and which is nested Form like: ReactiveFormGroup,AddressFormGroup etc.
      if (overrideObj?.template_schema) {
        overrideTemplateSchema(overrideObj)
      }
    } else {
      // override one filed and which is nested Form like: ReactiveFormGroup,AddressFormGroup etc.
      if (schemaItem?.template_schema) {
        overrideTemplateSchema(schemaItem)
      }
    }
  }
}

export const handleOverride = async (allJson) => {
  const { steps } = allJson

  for (let idx = 0; idx < steps.length; idx++) {
    let stepItem = steps[idx]
    for (let index = 0; index < stepItem.form.length; index++) {
      let formItem = stepItem.form[index]
      let formItemPath = `steps[${idx}]form[${index}]`

      if (formItem.override) {
        const overrideObj = await findOverrideSchema(formItem.override.name)

        formItem = {
          ...overrideObj,
          ...formItem
        }
        // form section override have override schema
        lodashSet(allJson, formItemPath, formItem)
        await findAndSetSchema(allJson, lodashGet(allJson, formItemPath), idx, index)
      } else {
        // one schema filed  override
        await findAndSetSchema(allJson, formItem, idx, index)
      }
    }
  }
  return allJson
}
